'use client';
import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { gql, useMutation } from '@apollo/client';
import Header from '../components/Header';

const ALTERAR_SENHA = gql`
  mutation AlterarSenha($novaSenha: String!, $senhaAtual: String!) {
    alterarSenha(novaSenha: $novaSenha, senhaAtual: $senhaAtual)
  }
`;


const Password: React.FC = () => {
    const [senhaAtual, setSenhaAtual] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmarNovaSenha, setConfirmarNovaSenha] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const [alterarSenha, { loading }] = useMutation(ALTERAR_SENHA);

    const validate = () => {
        if (novaSenha !== confirmarNovaSenha) {
            setErrorMsg('As senhas não conferem.');
            return false;
        }
        if (
            novaSenha.length < 8 ||
            !/[A-Z]/.test(novaSenha) ||
            !/[a-z]/.test(novaSenha) ||
            !/[0-9]/.test(novaSenha)
        ) {
            setErrorMsg(
                'A senha deve possuir ao menos 8 caracteres, uma letra maiúscula, uma letra minúscula e um número.'
            );
            return false;
        }
        return true;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setErrorMsg('');
        setSuccessMsg('');

        if (!validate()) {
            return;
        }

        try {
            await alterarSenha({ variables: { novaSenha, senhaAtual } });
            setSuccessMsg('Senha alterada com sucesso.');
            setSenhaAtual('');
            setNovaSenha('');
            setConfirmarNovaSenha('');
        } catch (err: any) {
            const msg = err?.message || 'Erro ao alterar senha.';
            setErrorMsg(msg);
        }
    };

    return (
        <Fragment>
            <div className="main-wrapper">
                <Header />


                <div className="main-content theme-dark-bg right-chat-active">

                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="middle-wrap">
                                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                        <Link to="/defaultsettings" className="d-inline-block mt-2"><i className="ti-arrow-left font-sm text-white"></i></Link>
                                        <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">Alterar senha</h4>
                                    </div>
                                    <div className="card-body p-lg-5 p-4 w-100 border-0">
                                        {errorMsg && (
                                            <div className="alert alert-danger" role="alert">
                                                {errorMsg}
                                            </div>
                                        )}
                                        {successMsg && (
                                            <div className="alert alert-success" role="alert">
                                                {successMsg}
                                            </div>
                                        )}
                                        <form onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-gorup">
                                                        <label className="mont-font fw-600 font-xssss">Senha atual</label>
                                                        <input
                                                            type="password"
                                                            className="form-control"
                                                            value={senhaAtual}
                                                            onChange={(e) => setSenhaAtual(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-gorup">
                                                        <label className="mont-font fw-600 font-xssss">Nova Senha</label>
                                                        <input
                                                            type="password"
                                                            className="form-control"
                                                            value={novaSenha}
                                                            onChange={(e) => setNovaSenha(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-gorup">
                                                        <label className="mont-font fw-600 font-xssss">Confirmar Nova Senha</label>
                                                        <input
                                                            type="password"
                                                            className="form-control"
                                                            value={confirmarNovaSenha}
                                                            onChange={(e) => setConfirmarNovaSenha(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 mb-0">
                                                    <button
                                                        type="submit"
                                                        disabled={loading}
                                                        className="bg-current text-center text-white font-xsss fw-600 p-3 w175 rounded-3 d-inline-block"
                                                        style={{border: 'none', cursor: loading ? 'not-allowed' : 'pointer'}}
                                                    >
                                                        {loading ? 'Salvando...' : 'SALVAR'}
                                                    </button>
                                                </div>
                                            </div>


                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </Fragment>
    )
}

export default Password